import { ReactComponent as RemoveOutline } from 'assets/icons/icon-remove-outline.svg';

export default RemoveOutline;
